import React from "react";
import Layout from "../components/layout";

const IndexPage = () => (
  <div className="AboutPage">
    <Layout>
      <div className="main">
        <div className="sidebyside">
          <div className="intro">
            <h1>Hi! I'm Julian.</h1>
            <h2>
              UX researcher & designer-who-codes, civic/urbanism nerd,
              sociolinguist, trans guy, doodler, Thai speaker, foodie, artist.
            </h2>
          </div>
          <div>
            <img
              className="jl-img"
              src="https://res.cloudinary.com/juleon/image/upload/v1566726103/JAL/JulianImg_1x.jpg"
              alt="Julian Avery Leonard. Hi!"
            />
            {/* <GraphicObject src="https://res.cloudinary.com/juleon/image/upload/v1563616700/JAL/graphic-sketches-doodles/sketching10030bgremoved90.png" />
            <GraphicObject src="https://res.cloudinary.com/juleon/image/upload/v1563616693/JAL/graphic-sketches-doodles/sketching10054bgremoved90.png" />
            <GraphicObject src="https://res.cloudinary.com/juleon/image/upload/v1563616713/JAL/graphic-sketches-doodles/sketching10012bgremoved90.png" /> */}
          </div>
        </div>
      </div>
      <div className="section2">
        <div className="main">
          <div className="sidebyside">
            <div className="intro">
             
              <p>
              I help teams build clear, simple, usable digital tools that people can use to access information and resources like mobility, education, health and safety, and community, and to organize or advocate for their needs.
              </p>

              <p>
                For the past three years I've been a <a href="/college">UX designer at College Board</a>, where my work is focused on redesigning and improving the usability of student-facing
                tools for college access, affordability, and financial assistance. Prior to that, as a freelance product designer, I consulted to and embedded with mission-driven
                early-stage <a href="/nise">startups</a> and <a href="/impakt">nonprofits</a>. I am also active in volunteering and pro bono work for <a href="https://elizabethwarren.com">progressive political campaigns</a>.
              </p> 

              <p>
                I love guiding teams through thoughtful, critical engagement
                with the problems our users face, working through technical
                possibilities, learning from users themselves, visualizing ideas
                and problem-solving together on paper, at the whiteboard, in
                graphics, and in code.
              </p>

              <p>
              I design out of a deep respect for and curiosity about people, their value systems and conceptions of the world, and the many ways they live their lives, and also out of a recognition that the way software is designed, and the way human stories are represented, has the capacity to exacerbate existing inequalities in access to resources, community, and the freedom to live one’s life in dignity.
              </p>

              <p>
                I think a lot about how social systems of power work, and why.
                Much of our experience of the world has been shaped, bit by bit,
                by people on teams in institutions making decisions. That’s
                design.{" "}
              </p>

              <p>
          
                As designers – of tools and tasks, of work, of how people
                interact – I believe we have an ethical responsibility to think imaginatively beyond the status quo to ways things could be better, more inclusive and effective.
                Once we have deeply informed ourselves about the problem at
                hand, we must reexamine the questions of who we are designing for,
                the kind of world our passive choices would support, and what we
                have the opportunity to change. It can be exciting work!
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </div>
);

export default IndexPage;
